<script setup lang="ts">
import type { CmsElementZebraCmsExpandableText } from "~/composables/useCustom";

const props = defineProps<{
  content: CmsElementZebraCmsExpandableText;
}>();

const {mainText, backgroundMobile, backgroundDesktop } = props.content?.config

</script>
<template>
  <div class="hero-section relative">
    <figure class="w-full h-[700px] md:h-full">
      <template v-if="backgroundDesktop.value && backgroundMobile.value">
        <NuxtImg format="webp" loading="lazy" v-if="backgroundDesktop.value" width="1920" :src="backgroundDesktop.value.url" class="img-cover md:min-h-[480px] hidden md:block" alt="" />
        <NuxtImg format="webp" loading="lazy" v-if="backgroundMobile.value" width="768"  :src="backgroundMobile.value.url" class="img-cover lg:min-h-[480px] md:hidden" alt="" />
      </template>
      <template v-else-if="backgroundDesktop.value">
        <NuxtImg format="webp" loading="lazy" :src="backgroundDesktop.value.url" width="1920"  class="img-cover" alt="" />
      </template>
      <template v-else-if="backgroundMobile.value">
        <NuxtImg format="webp" loading="lazy" :src="backgroundMobile.value.url" width="1920" class="img-cover" alt="" />
      </template>
    </figure>
    <div class="absolute top-1/2 -translate-y-1/2 start-0 w-full z-20">
      <div class="max-w-[560px] px-4 text-center block m-auto">
        <div class="text-white cms-light-header" v-html="mainText.value"></div>
      </div>
    </div>
  </div>
</template>
